module.exports = __webpack_public_path__ + "static/media/screen-3.d11cd6fa.webp";